import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=0aaf5488&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=0aaf5488&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf5488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aaf5488')) {
      api.createRecord('0aaf5488', component.options)
    } else {
      api.reload('0aaf5488', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=0aaf5488&scoped=true", function () {
      api.rerender('0aaf5488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/Overview.vue"
export default component.exports